const translation = {
  tags: {
    weather: 'อากาศ',
    finance: 'การเงิน',
    social: 'สังคม',
    entertainment: 'มหรสพ',
    education: 'การศึกษา',
    news: 'ข่าว',
    design: 'ออกแบบ',
    agent: 'ตัวแทน',
    videos: 'วิดีโอ',
    utilities: 'สาธารณูปโภค',
    search: 'ค้น',
    business: 'ธุรกิจ',
    productivity: 'ผลิตภาพ',
    travel: 'เดินทาง',
    medical: 'ทางการแพทย์',
    image: 'ภาพ',
    other: 'อื่นๆ',
  },
  searchTags: 'แท็กค้นหา',
  allTags: 'แท็กทั้งหมด',
}

export default translation
